import { render, staticRenderFns } from "./HoldBalanceDialog.vue?vue&type=template&id=a0db9a98&scoped=true"
import script from "./HoldBalanceDialog.vue?vue&type=script&lang=js"
export * from "./HoldBalanceDialog.vue?vue&type=script&lang=js"
import style0 from "./HoldBalanceDialog.vue?vue&type=style&index=0&id=a0db9a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0db9a98",
  null
  
)

export default component.exports